/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import clsx from "clsx";

interface IFilter {
    filterCount: any;
    filterKeyValue: any;
    filterDataLabel: any;
    filterDataValue: any;
    active: any;
    onSelect: any;
    onDeselect?: any;
    clearSelection: boolean;
}
const FilterValue = ({
    filterCount,
    filterKeyValue,
    filterDataLabel,
    filterDataValue,
    active,
    onSelect,
    onDeselect,
    clearSelection,
}: IFilter) => {
    const [selected, setSelected] = React.useState(active);

    React.useEffect(() => {
        if (selected)
            onSelect({
                key: filterKeyValue,
                value: filterDataValue,
            });
        else
            if(onDeselect)
                onDeselect({
                    key: filterKeyValue,
                    value: filterDataValue,
                });
    }, [selected]);

    React.useEffect(() => {
        if (clearSelection) setSelected(false);
    }, [clearSelection]);

    React.useEffect(() => {
        if (filterCount === 0) setSelected(false);
    }, [filterCount]);

    const handleClick = () => {
        setSelected(!selected);
    };

    return (
        <button
            onKeyDown={() => {}}
            tabIndex={0}
            className={clsx(
                "rounded-[4px] text-base font-semibold px-[6px] py-1 cursor-pointer border",
                { "border-purple-900 text-purple-900": selected || active },
                { "border-gray-200 text-gray-700": !selected && !active }
            )}
            onClick={handleClick}
        >
            {filterDataLabel}
        </button>
    );
};

export default FilterValue;
